import React from 'react';
import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { PromotionsTableBody } from './PromotionsTableBody';

export const PromotionsTableBodyWithDnD = ({
  data,
  setData,
  isDraggable,
  setCurID,
  openModal,
  permissions
}) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <PromotionsTableBody
        data={data}
        setData={setData}
        isDraggable={isDraggable}
        setCurID={setCurID}
        openModal={openModal}
        permissions={permissions}
      />
    </DndProvider>
  );
};

PromotionsTableBodyWithDnD.propTypes = {
  data: PropTypes.array,
  setData: PropTypes.func,
  isDraggable: PropTypes.bool,
  setCurID: PropTypes.func,
  openModal: PropTypes.func,
  permissions: PropTypes.object
};
